// IMPORTED DEPENDENCIES
import React from "react";
// import Select from 'react-select';

// IMPORTED COMPONENTS, STORES AND PAGES
import FileDirectory from "../FileDirectory.json";
import { useObjectStore } from "../zustand/objects";

import ModelPoses from '../ModelPoses.json';

import { Select } from '@mantine/core';

import { nanoid } from 'nanoid'

// THIS COMPONENT
const ModelDropdown = ({ category }) => {


    // STORE, STATE, ETC
    const { addObject, currentObjectArtboard, switchTextModalOpen, switchUploadModalOpen, switchImageModalOpen, setImagePurpose, arrangeUndoRedo } = useObjectStore();

    const textArray = [
        { value: "plain text", label: "plain text" }
    ]

    const imageArray = [
        { value: "object", label: "custom image" },
        { value: "figma", label: "link to figma frame" },
        { value: "apple", label: "Apple UI elements" },
        { value: "microsoft", label: "Microsoft UI elements" },
        { value: "floatgridsUi", label: "FloatGrids UI elements" },
        { value: "floatgridsLayout", label: "FloatGrids layouts" }
    ]

    const shapeArray = [
        { value: "cone", label: "cone" },
        { value: "cube", label: "cube" },
        { value: "cylinder", label: "cylinder" },
        { value: "roundedBox", label: "roundedBox" },
        { value: "sphere", label: "sphere" },
    ]


    // FUNCTIONS 
    const handleChange = (e) => {
        const newID = nanoid()
        // send update to zustand first (so we have state to grab for undo array)
        if (category === "shape") {
            addObject({
                currentObjectArtboard,
                category: category,
                object: e.value,
                undo: false,
                id: newID,
                position: null,
                scale: null,
                rotation: null,
                matrix: null,
                pose: {
                    name: ModelPoses[e.value] ? ModelPoses[e.value][0] : null,
                    modelPath: null
                },
                imageTexture: null,
                image: null,
                curved: false,
                curveAmount: 3,
                bGColour: null
            })
        }
        else if (
            (e.value === 'apple') ||
            (e.value === 'microsoft') ||
            (e.value === 'floatgridsLayout') ||
            (e.value === 'floatgridsUi')
        ) {
            addObject({
                currentObjectArtboard,
                category: e.value,
                object: e.value,
                undo: false,
                id: newID,
                position: null,
                scale: null,
                rotation: null,
                matrix: null,
                pose: {
                    name: ModelPoses[e.value] ? ModelPoses[e.value][0] : null,
                    modelPath: null
                },
                imageTexture: null,
                image: null,
                curved: false,
                curveAmount: 3,
                bGColour: null
            })
        } else {
            addObject({
                currentObjectArtboard,
                category: category,
                object: JSON.parse(e.value).name,
                undo: false,
                id: newID,
                position: null,
                scale: null,
                rotation: null,
                matrix: null,
                pose: {
                    name: JSON.parse(e.value).default_pose.name,
                    modelPath: JSON.parse(e.value).default_pose.path
                },
                imageTexture: null,
                image: null,
                curved: false,
                curveAmount: 3,
                bGColour: null,
            })
        }
        // send current state to undoActions
        arrangeUndoRedo({
            updateType: "objectAdd",
            artboard: currentObjectArtboard,
            objectID: newID,
            undo: false
        })
    };

    const onAddTextClick = () => {
        switchTextModalOpen()
    }
    const onAddImageClick = (e) => {
        switchImageModalOpen()
        // setImagePurpose(e.value)
    }
    const onAddUploadClick = () => {
        switchUploadModalOpen()
    }

    // RETURNED JSX
    if (category === "text") {
        return (
            <div style={{ width: 220 }}>

                <Select
                    w={220}
                    action="clear"
                    placeholder={"Add " + category}
                    onChange={() =>
                        onAddTextClick()
                    }
                    data={textArray.map((mapped) => (
                        { value: mapped.value, label: mapped.label }
                    ))
                    }
                />
            </div>
        )
    }
    // RETURNED JSX
    else if (category === "image") {
        return (
            <div style={{ width: 220 }}>

                <Select
                    w={220}
                    action="clear"
                    placeholder={"Add image/UI"}
                    onChange={(e) => console.log(e) && e === 'apple' ? handleChange({ value: e }) : e === 'microsoft' ? handleChange({ value: e }) : e === 'floatgridsUi' ? handleChange({ value: e }) : e === 'floatgridsLayout' ? handleChange({ value: e })
                        : onAddImageClick({ value: e })
                    }

                    data={imageArray.map((mapped) => (
                        { value: mapped.value, label: mapped.label }
                    ))
                    }
                />
            </div>
        )
    }
    else if (category === "uploaded") {
        return (
            <div style={{ width: 220 }}>
                <button onClick={onAddUploadClick}>Upload a model</button>
            </div>)
    }
    else if (category === "shape") {
        return (
            <div style={{ width: 220 }}>
                <Select
                    w={220}
                    // action="clear"
                    placeholder={"Add " + category}
                    onChange={(e) =>
                        handleChange({ value: e })
                    }
                    data={shapeArray.map((mapped) => (
                        { value: mapped.value, label: mapped.label }
                    ))
                    }
                /></div>
        )
    }
    else if (category === "UI") {
        return (

            <Select
                w={220}
                action="clear"
                placeholder={"Add " + category}
                onChange={(e) =>
                    handleChange({ value: e })
                }
                data={FileDirectory[category].map((mapped) => (
                    { value: mapped.name, label: mapped.name }
                ))
                }
            />
        )
    }
    else {
        return (
            <Select
                w={220}
                action="clear"
                placeholder={"Add " + category.replace(/([A-Z])/g, " $1").toLowerCase()}
                onChange={(e) =>
                    handleChange({ value: e })
                }
                data={Object.keys(FileDirectory[category]).map((mapped) => (
                    {
                        group: mapped,
                        items: FileDirectory[category][mapped].map((option) => (
                            { value: JSON.stringify(option), label: option.name }
                        )
                        )
                    }

                ))
                }
            />
        );
    }
}

export default ModelDropdown; 